import { render, staticRenderFns } from "./RelationshipManagement.vue?vue&type=template&id=42e67fb5&scoped=true"
import script from "./RelationshipManagement.vue?vue&type=script&lang=js"
export * from "./RelationshipManagement.vue?vue&type=script&lang=js"
import style0 from "./RelationshipManagement.vue?vue&type=style&index=0&id=42e67fb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e67fb5",
  null
  
)

export default component.exports